function InvalidInstanceException(message) {
  this.message = message;
  this.name = 'InvalidInstanceException';
}

export { InvalidInstanceException }; // eslint-disable-line import/prefer-default-export
